import React, { useState, useEffect } from "react";
import axios from 'axios';
import Cards from "../../components/Cards/Cards";

function BrandPage({ onBrandSelect }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const urlEndpoint = window.urlEndpoint;

  useEffect(() => {
    axios.get(`https://api.quieromac.com/retomas/inventory/celucambio/brands?categories=Apple,Android`)
      .then(response => {
        const sortedData = response.data.data.sort((a, b) => a.localeCompare(b));
        setData(sortedData);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  
  return (
    <div className="brandPage">
      <p className="textBlack">¡Renueva tu equipo!</p>
      <h1>Descubre cuánto ofrecemos por tu celular.</h1>
      <p className="description">
        Con este intercambio, <span>¡actualiza a uno nuevo!</span> Ya sea{" "}
        <span>en línea o en una tienda Celucambio o aliada,</span> siempre
        garantizamos una gran oferta por tu dispositivo.
      </p>
      <div>
        <h2>Primero, ¿Cuál es la marca de tu celular?</h2>
        <Cards list={data} type="brand" onBrandSelect={onBrandSelect} />
      </div>
    </div>
  );
}

export default BrandPage;
